<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';
import MediaExtractedContent from './MediaExtractedContent.vue';

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});
</script>

<template>
  <BaseBubble class="px-3 py-3" data-bubble-name="audio">
    <div class="flex flex-col gap-2">
      <AudioChip
        :attachment="attachment"
        :show-transcribed-text="false"
        class="p-2 text-n-slate-12 skip-context-menu"
      />
      <MediaExtractedContent :attachment-id="attachment.id" />
    </div>
  </BaseBubble>
</template>
